// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var H3 = function H3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.5 4.75A.75.75 0 0 0 .75 4a.75.75 0 0 0-.75.75v10.5c0 .416.334.75.75.75s.75-.334.75-.75V10.5h7v4.75c0 .416.334.75.75.75s.75-.334.75-.75V4.75A.75.75 0 0 0 9.25 4a.75.75 0 0 0-.75.75V9h-7zm11-.75a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h4.44L13.22 9.219a.751.751 0 0 0 .531 1.281h2.75c1.103 0 2 .897 2 2s-.897 2-2 2h-2.269c-.487 0-.906-.353-.987-.834l-.006-.038a.75.75 0 0 0-.863-.616.75.75 0 0 0-.616.863l.007.037A2.5 2.5 0 0 0 14.23 16H16.5c1.934 0 3.5-1.566 3.5-3.5S18.434 9 16.5 9h-.94l3.721-3.719A.751.751 0 0 0 18.75 4z"
  }));
};
